import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import HeaderBar from './components/HeaderBar';
import Logo from './components/Logo';
import ServicesSection from './components/ServicesSection';
import SloganSection from './components/SloganSection';
import ContactUsSection from './components/ContactUsSection';
import registerServiceWorker from './registerServiceWorker';
import {IntlProvider} from 'react-intl';
import zh_cn from "./zh_cn";
import en_us from "./en_us";
import zh_hk from "./zh_hk";
import FooterSection from "./components/FooterSection";

function selectLangData() {

    switch (window.location.pathname) {
        case '/en':
            return en_us;

        case '/hk':
            return zh_hk;

        case '/cn':
            return zh_cn;

        default:
            return en_us;

    }
}


// ReactDOM.render(
//     <IntlProvider
//         locale={'en'}
//         messages={selectLangData()}>
//         <Title />
//     </IntlProvider>, document.getElementById('title_bar'));


ReactDOM.render(
    <IntlProvider
        locale={'en'}
        messages={selectLangData()}>
        <Logo/>
    </IntlProvider>, document.getElementById('logo'));

ReactDOM.render(
    <IntlProvider
        locale={'en'}
        messages={selectLangData()}>
        <HeaderBar/>
    </IntlProvider>, document.getElementById('nav-menu-container'));

ReactDOM.render(
    <IntlProvider
        locale={'en'}
        messages={selectLangData()}>
        <SloganSection/>
    </IntlProvider>, document.getElementById('slogan_section'));

ReactDOM.render(
    <IntlProvider
        locale={'en'}
        messages={selectLangData()}>
        <ServicesSection/>
    </IntlProvider>, document.getElementById('services_section'));

ReactDOM.render(
    <IntlProvider
        locale={'en'}
        messages={selectLangData()}>
        <ContactUsSection/>
    </IntlProvider>, document.getElementById('contact_us_section'));

ReactDOM.render(
    <IntlProvider
        locale={'en'}
        messages={selectLangData()}>
        <FooterSection/>
    </IntlProvider>, document.getElementById('footer_section'));

registerServiceWorker();







// WEBPACK FOOTER //
// ./src/index.js